// Hirá: gentle fade-up for homepage sections as they scroll into view.
// The hero is skipped so above-the-fold content (and LCP) is never delayed.
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return; // keep the theme editor static

  const sections = [...document.querySelectorAll('main > .shopify-section')].slice(1);
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('hira-reveal--in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (const section of sections) {
    // Anything already on screen at load shows immediately.
    if (section.getBoundingClientRect().top < window.innerHeight) continue;
    section.classList.add('hira-reveal');
    observer.observe(section);
  }
})();
